// extracted by mini-css-extract-plugin
export var attachment = "_mn-a";
export var emailContainer = "_mn-4";
export var emailContentPaddedContainer = "_mn-b";
export var emailHeader = "_mn-6";
export var emailIframe = "_mn-3";
export var emailInfoIcon = "_mn-9";
export var emailShortenedSummary = "_mn-e";
export var infoDropdown = "_mn-0";
export var infoRowBoundedContent = "_mn-d";
export var internal = "_mn-5";
export var merchant = "_mn-8";
export var messageInputContainer = "_mn-h";
export var normal = "_mn-7";
export var replyCard = "_mn-f";
export var subtleButton = "_mn-1";
export var subtleButtonIconContainer = "_mn-2";
export var toggleViewRepliesButton = "_mn-c";
export var wrappingText = "_mn-g";